<template>
  <div style="display: grid;">
    <div class="mb-2" style="margin-left: -24px;">
      <ul class="step-menu">
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Customer Information</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Consignee / Shipper</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Billing Information</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Required Documents</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Additional</div>
        </li>
      </ul>
    </div>
    <div v-if="isLoadingSaf" class="_documents__container">
      <half-circle-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
      />
    </div>
    <div v-else id="formLast" class="scroller mt-4" style="margin-left: 16px;margin-right: 27px;">
      <div class="mb-4">
        <div class="d-flex align-items-center">
          <p class="mr-1" style="font-weight: 600;font-size: 14px;">
            Do you have any existing or on going negotiation of contract with
            Andalin?<span style="color: red;">*</span>
          </p>
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-b-tooltip.hover.rightbottom="
              'Contract based : Continous shipment/Multiple shipment RFQ based : One time shipment'
            "
            variant="primary"
            @mouseover="hovered"
            @mouseleave="hoveredOut"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.4016 8.37656C14.4016 11.9112 11.5362 14.7766 8.00156 14.7766C4.46694 14.7766 1.60156 11.9112 1.60156 8.37656C1.60156
              4.84194 4.46694 1.97656 8.00156 1.97656C11.5362 1.97656 14.4016 4.84194 14.4016 8.37656ZM8.80156 5.17656C8.80156 5.61839 8.44339
              5.97656 8.00156 5.97656C7.55973 5.97656 7.20156 5.61839 7.20156 5.17656C7.20156 4.73473 7.55973 4.37656 8.00156 4.37656C8.44339
              4.37656 8.80156 4.73473 8.80156 5.17656ZM7.20156 7.57656C6.75973 7.57656 6.40156 7.93473 6.40156 8.37656C6.40156 8.81839 6.75973
              9.17656 7.20156 9.17656V11.5766C7.20156 12.0184 7.55973 12.3766 8.00156 12.3766H8.80156C9.24339 12.3766 9.60156 12.0184 9.60156
              11.5766C9.60156 11.1347 9.24339 10.7766 8.80156 10.7766V8.37656C8.80156 7.93473 8.44339 7.57656 8.00156 7.57656H7.20156Z"
              :fill="colorHover"
            />
          </svg>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <b-form-radio-group v-model="selectedNegotation">
            <b-form-radio value="yes">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">
                Yes
              </p>
            </b-form-radio>
            <b-form-radio style="margin-left: 20px;" value="no">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">
                No
              </p>
            </b-form-radio>
          </b-form-radio-group>
        </div>
      </div>
      <div v-if="selectedNegotation === 'yes'">
        <p style="font-weight: 600;font-size: 14px;">
          You may upload Signed Contract or send Draft Contract
        </p>
        <p style="font-size: 14px;">Upload Sign Contract<span style="color: red;">*</span></p>
        <div v-if="!uploadDoc">
          <div
            class="form-control col-4 mb-2 mt-2"
            style=" height: calc(1.5em + 0.75rem + 6px) !important"
          >
            <b-form-file
              style="font-size: 14px;"
              v-model="uploadDoc"
              plain
            ></b-form-file>
          </div>
        </div>
        <div v-else class="d-flex align-items-center mt-2 text-left">
          <img
            class="pl-2"
            src="@/assets/image/icon/document-text.svg"
            alt=""
          />
          <p class="pl-2 py-1 mr-1" style="font-size: 12px;">
            <i style="word-break: break-all;">{{
              uploadDoc ? uploadDoc.name : ""
            }}</i>
          </p>
          <img
            class="pl-2"
            src="@/assets/image/icon/x-circle.svg"
            style="cursor: pointer"
            alt=""
            @click="resetModalUploadDoc()"
          />
        </div>
      </div>
      <div v-if="selectedNegotation === 'no'" class="mb-4">
        <div class="d-flex align-items-center">
          <p style="font-weight: 600;font-size: 14px;">
            Is the shipment ToP-based?<span style="color: red;">*</span>
          </p>
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-b-tooltip.hover.rightbottom="
              'Terms of Payment (TOP) by default is 14 days. Please contact our sales team if you want to increase the TOP.'
            "
            variant="primary"
            @mouseover="hoveredTOP"
            @mouseleave="hoveredOutTOP"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.4016 8.37656C14.4016 11.9112 11.5362 14.7766 8.00156 14.7766C4.46694 14.7766 1.60156 11.9112 1.60156 8.37656C1.60156
              4.84194 4.46694 1.97656 8.00156 1.97656C11.5362 1.97656 14.4016 4.84194 14.4016 8.37656ZM8.80156 5.17656C8.80156 5.61839 8.44339
              5.97656 8.00156 5.97656C7.55973 5.97656 7.20156 5.61839 7.20156 5.17656C7.20156 4.73473 7.55973 4.37656 8.00156 4.37656C8.44339
              4.37656 8.80156 4.73473 8.80156 5.17656ZM7.20156 7.57656C6.75973 7.57656 6.40156 7.93473 6.40156 8.37656C6.40156 8.81839 6.75973
              9.17656 7.20156 9.17656V11.5766C7.20156 12.0184 7.55973 12.3766 8.00156 12.3766H8.80156C9.24339 12.3766 9.60156 12.0184 9.60156
              11.5766C9.60156 11.1347 9.24339 10.7766 8.80156 10.7766V8.37656C8.80156 7.93473 8.44339 7.57656 8.00156 7.57656H7.20156Z"
              :fill="colorHoverTOP"
            />
          </svg>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <b-form-radio-group v-model="selectedTop">
            <b-form-radio value="yes">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">
                Yes
              </p>
            </b-form-radio>
            <b-form-radio style="margin-left: 20px;" value="no">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">
                No
              </p>
            </b-form-radio>
          </b-form-radio-group>
        </div>
      </div>
      <div v-if="selectedTop === 'yes'" class="mb-4">
        <p style="font-weight: 600;font-size: 14px;">
          Is the shipment destination to US/Europe?
        </p>
        <div class="d-flex justify-content-between align-items-center">
          <b-form-radio-group v-model="selectedTopDestination">
            <b-form-radio value="yes">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">
                Yes
              </p>
            </b-form-radio>
            <b-form-radio style="margin-left: 20px;" value="no">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">
                No
              </p>
            </b-form-radio>
          </b-form-radio-group>
        </div>
      </div>
      <div v-if="selectedTopDestination === 'yes'" class="mb-2">
        <p class="mb-2" style="font-size: 14px;">
          Based on your needs, your Credit Limit will be granted Rp 150.000.000
          with TOP 14 days'
        </p>
        <!-- <p style="font-weight: 600;font-size: 14px;">Do you wish to modify?</p>
        <div class="d-flex justify-content-between align-items-center">
          <b-form-radio-group v-model="selectedModify">
            <b-form-radio value="yes">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">Yes</p>
            </b-form-radio>
            <b-form-radio style="margin-left: 20px;" value="no">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">No</p>
            </b-form-radio>
          </b-form-radio-group>
        </div> -->
      </div>
      <div v-if="selectedTopDestination === 'no'" class="mb-2">
        <p class="mb-2" style="font-size: 14px;">
          Based on your needs, your Credit Limit will be granted Rp 50.000.000
          with TOP 14 days'
        </p>
        <!-- <p style="font-weight: 600;font-size: 14px;">Do you wish to modify?</p>
        <div class="d-flex justify-content-between align-items-center">
          <b-form-radio-group v-model="selectedModify">
            <b-form-radio value="yes">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">Yes</p>
            </b-form-radio>
            <b-form-radio style="margin-left: 20px;" value="no">
              <p style="font-size: 12px; line-height: 2; font-weight: 600;">No</p>
            </b-form-radio>
          </b-form-radio-group>
        </div> -->
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-center mr-4">
      <button class="btn btn-white-blue mr-2" @click="onSelectedTabBack">
        Back
      </button>
      <div class="btn btn-white-blue mr-2" @click="saveDraft">Save Draft</div>
      <button
        class="btn btn-white-blue"
        :disabled="submitValidation"
        @click="submitSaf"
      >
        <span v-if="isLoadingPostSubmit">Loading...</span>
        <span v-else>Submit</span>
      </button>
    </div>
    <div class="_modals">
      <b-modal
        id="modalUploadDocument"
        ref="modalConfirm"
        hide-footer
        hide-header-close
        centered
        title="Save As Draft"
      >
        <div class="text-center">
          <p class="mb-4">
            Any uploaded document in this section will not be saved if you click
            “Save as Draft” now.
          </p>
          <p class="mb-4" style="font-weight: 700;">
            Do you want to save this progress as a draft?
          </p>
          <div class="d-flex justify-content-center">
            <button
              @click="closeSuccessModal"
              class="button__redcorporite mr-2"
            >
              No
            </button>
            <button @click="saveDraftModal" class="button__bluecorporite">
              Yes
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalSuccessUpload"
        ref="modalSuccessSubmit"
        hide-footer
        hide-header-close
        centered
      >
        <div class="text-center">
          <img class="mb-2" src="@/assets/image/icon/success-blue.svg" alt="" />
          <p class="mb-2">Progress submit has been success.</p>
          <!-- <button @click="closeSuccessModal" class="button__bluecorporite">Ok</button> -->
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  name: 'form5',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      selectedNegotation: '',
      selectedTop: '',
      selectedTopDestination: '',
      selectedModify: '',
      uploadDoc: '',
      submitValidation: true,
      colorHover: '#D2D6DD',
      colorHoverTOP: '#D2D6DD'
    }
  },
  computed: {
    ...mapGetters({
      saf: 'settingSaf/saf',
      errorSaf: 'settingSaf/errorSaf',
      isLoadingSaf: 'settingSaf/isLoadingSaf',
      isErrorPostsaf: 'settingSaf/isErrorPostsaf',
      isLoadingPostSubmit: 'settingSaf/isLoadingPostSubmit'
    })
  },
  created () {
    this.$eventHub.$on('dialog-payload-save-draft', this.fetchSaf)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-payload-save-draft')
  },
  watch: {
    selectedNegotation (data) {
      if (data === 'yes') {
        if (!this.saf.additional.existing_contract) {
          this.selectedTop = ''
        }
        this.selectedTopDestination = ''
        this.selectedModify = ''
        this.submitValidation = true
      } else {
        this.submitValidation = true
      }
    },
    uploadDoc (data) {
      if (data) {
        this.submitValidation = false
      } else {
        this.submitValidation = true
      }
    },
    selectedTop (data) {
      if (data) {
        if (!this.saf.additional.top_based) {
          this.selectedTopDestination = ''
        }
        if (data === 'yes') {
          this.submitValidation = true
        } else {
          this.submitValidation = false
        }
      }
    },
    selectedTopDestination (data) {
      if (data) {
        this.submitValidation = false
      }
    }
  },
  async mounted () {
    await this.fetchSaf()
  },
  methods: {
    async fetchSaf () {
      await this.$store.dispatch('settingSaf/FETCH_SAF_SAVE_DRAFT').then(() => {
        if (this.saf) {
          const data = this.saf.additional
          this.selectedNegotation =
            data.existing_contract === 1
              ? 'yes'
              : data.existing_contract === 0
                ? 'no'
                : ''
          this.selectedTop =
            data.top_based === 1 ? 'yes' : data.top_based === 0 ? 'no' : ''
          this.selectedTopDestination =
            data.shipment_to_europe === 1
              ? 'yes'
              : data.shipment_to_europe === 0
                ? 'no'
                : ''
        }
      })
    },
    async saveDraft () {
      if (this.uploadDoc) {
        this.$refs.modalConfirm.show()
      } else {
        const payload = {
          existing_contract:
            this.selectedNegotation === 'yes'
              ? 1
              : this.selectedNegotation === 'no'
                ? 0
                : null,
          top_based:
            this.selectedTop === 'yes'
              ? 1
              : this.selectedTop === 'no'
                ? 0
                : null,
          shipment_to_europe:
            this.selectedTopDestination === 'yes'
              ? 1
              : this.selectedTopDestination === 'no'
                ? 0
                : null,
          credit_limit:
            this.selectedTopDestination === 'yes'
              ? '150000000'
              : this.selectedTopDestination === 'no'
                ? '50000000'
                : null
        }
        this.$emit('Draft', payload)
        // this.$eventHub.$emit('dialog-payload-save-draft', payload)
        await this.fetchSaf()
      }
    },
    async saveDraftModal () {
      const payload = {
        existing_contract:
          this.selectedNegotation === 'yes'
            ? 1
            : this.selectedNegotation === 'no'
              ? 0
              : null,
        top_based:
          this.selectedTop === 'yes' ? 1 : this.selectedTop === 'no' ? 0 : null,
        shipment_to_europe:
          this.selectedTopDestination === 'yes'
            ? 1
            : this.selectedTopDestination === 'no'
              ? 0
              : null,
        credit_limit:
          this.selectedTopDestination === 'yes'
            ? '150000000'
            : this.selectedTopDestination === 'no'
              ? '50000000'
              : null
      }
      this.$emit('Draft', payload)
      // this.$eventHub.$emit('dialog-payload-save-draft', payload)
      await this.fetchSaf()
      this.closeSuccessModal()
      this.resetModalUploadDoc()
    },
    async submitSaf () {
      const section1 = JSON.parse(localStorage.getItem('data'))
      const payload = {
        existing_contract:
          this.selectedNegotation === 'yes'
            ? 1
            : this.selectedNegotation === 'no'
              ? 0
              : null,
        top_based:
          this.selectedTop === 'yes' ? 1 : this.selectedTop === 'no' ? 0 : null,
        shipment_to_europe:
          this.selectedTopDestination === 'yes'
            ? 1
            : this.selectedTopDestination === 'no'
              ? 0
              : null,
        credit_limit:
          this.selectedTopDestination === 'yes'
            ? 150000000
            : this.selectedTopDestination === 'no'
              ? 50000000
              : 0,
        contract_file: this.uploadDoc ? this.uploadDoc : null
      }
      const allData = this.getFormData({ ...section1, ...payload })
      await this.$store.dispatch('settingSaf/POST_SAF_SUBMIT', allData).then(() => {
        if (!this.isLoadingPostSubmit) {
          this.$refs.modalSuccessSubmit.show()
          localStorage.removeItem('data')
          setTimeout(() => {
            this.$router.push('/settings/mydocuments')
          }, 2000)
        }
      })
    },
    getFormData (object) {
      let formData = new FormData()
      for (let [key, value] of Object.entries(object)) {
        if (key === 'shipment') {
          formData.append(key, JSON.stringify(value))
        } else {
          formData.append(key, value)
        }
      }
      return formData
    },
    onSelectedTabBack () {
      this.$emit('Back', 'form4')
    },
    closeSuccessModal () {
      this.$refs.modalConfirm.hide()
    },
    resetModalUploadDoc () {
      this.uploadDoc = null
    },
    hovered () {
      this.colorHover = '#1D3354'
    },
    hoveredOut () {
      this.colorHover = '#D2D6DD'
    },
    hoveredTOP () {
      this.colorHoverTOP = '#1D3354'
    },
    hoveredOutTOP () {
      this.colorHoverTOP = '#D2D6DD'
    }
  }
}
</script>

<style>
.bs-tooltip-auto[x-placement^="right"] .arrow::before,
.bs-tooltip-right .arrow::before {
  border-right-color: #1d3354 !important;
}
#formLast .tooltip-inner {
  background-color: #1d3354 !important;
  max-width: 391px !important;
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/saf/form5.vue